import { PortalError } from './PortalError';

export class KeepGroupVisibleError extends PortalError {
  constructor() {
    super('KeepGroupVisibleError', 'One group always has to be visible', 'one_group_visible_label');
  }
}
